import { AUTHORIZATION_LOGOUT_SUCCESS } from "../types";

export const actionLogout = (params) => {
  return async (dispatch) => {
    dispatch({
      type: AUTHORIZATION_LOGOUT_SUCCESS,
    });
  };
};
